import { Row, Col, Typography } from 'antd';
import useConfig from '../../core/modules/book/hooks/useConfig.query';
import { TABLEAU_AUTHOR_DETAILS_LINK_URL } from '../../core/constants/global-constants';
import ArrowUpperRight from '../../assets/icons/arrow-up-right.svg';

const { Link } = Typography;

// "/t/<site>/views/" -> "/#/site/<site>/views/". No-op if already browser form.
const toBrowserUrl = (embedUrl: string): string =>
  embedUrl.replace(/\/t\/([^/]+)\/views\//, '/#/site/$1/views/');

const OverlayTableauLink = ({ authorName }: { authorName?: string }) => {
  const { data: config } = useConfig();

  const configuredUrl = config?.tableau?.author_performance_view_url;
  const baseUrl = configuredUrl
    ? toBrowserUrl(configuredUrl)
    : TABLEAU_AUTHOR_DETAILS_LINK_URL;

  const href = authorName
    ? `${baseUrl}?Author=${encodeURIComponent(authorName)}`
    : baseUrl;

  return (
    <Row>
      <Col span={24} className='author-sales-col'>
        <Link
          href={href}
          target='_blank'
          rel='noopener noreferrer'
          className='author-sales-link'
        >
          See more author details on Tableau <img
            src={ArrowUpperRight}
            alt='Open in new tab'
            style={{ width: 16, height: 16, marginLeft: 4 }}
          />
        </Link>
      </Col>
    </Row>
  );
};

export default OverlayTableauLink;
